
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Aboutus",
      function () {
        return require("private-next-pages/Aboutus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Aboutus"])
      });
    }
  